import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../Navbar";
import Footer from "../Footer";

export default function LegalLayout({ title, kicker, lastUpdated, children }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    document.title = `${title} — MyDigitalAction`;
  }, [title]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Navbar />
      <main className="container-max pt-28 pb-20 md:pt-32 md:pb-24">
        <div className="mb-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors"
            data-testid="legal-back-home-btn"
          >
            <ArrowLeft size={14} /> Torna alla home
          </Link>
        </div>

        <div className="mb-8">
          <div className="font-mono-label text-white/40 text-[10px] tracking-widest mb-2">
            {kicker || "INFORMATIVA"}
          </div>
          <h1 className="font-display text-4xl md:text-5xl leading-[1.05] font-semibold tracking-tight">
            {title}
          </h1>
          {lastUpdated && (
            <div className="text-white/40 text-xs mt-4">Ultimo aggiornamento: {lastUpdated}</div>
          )}
        </div>

        <article className="prose-legal max-w-3xl text-white/75 text-[15px] leading-relaxed space-y-6">
          {children}
        </article>
      </main>
      <Footer />
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-display text-white text-2xl md:text-3xl font-semibold mt-10 mb-3 tracking-tight">{children}</h2>;
}
export function H3({ children }) {
  return <h3 className="font-display text-white text-lg md:text-xl font-semibold mt-6 mb-2">{children}</h3>;
}
export function P({ children }) {
  return <p className="text-white/70 leading-relaxed">{children}</p>;
}
export function Ul({ children }) {
  return <ul className="list-disc pl-6 space-y-2 text-white/70">{children}</ul>;
}
export function ServiceCard({ name, provider, country, purposes, dataTypes, privacyUrl }) {
  return (
    <div className="my-4 p-5 rounded-xl bg-white/[0.03] border border-white/10">
      <div className="flex items-baseline justify-between flex-wrap gap-2">
        <h4 className="font-display text-white text-base font-semibold">{name}</h4>
        <span className="text-[11px] text-white/40 font-mono">{country}</span>
      </div>
      <div className="text-white/50 text-xs mt-1">Fornitore: {provider}</div>
      <div className="mt-3 text-sm text-white/70"><strong className="text-white/85">Finalità:</strong> {purposes}</div>
      <div className="mt-1.5 text-sm text-white/70"><strong className="text-white/85">Dati trattati:</strong> {dataTypes}</div>
      {privacyUrl && (
        <a
          href={privacyUrl}
          target="_blank"
          rel="noreferrer noopener"
          className="inline-block mt-3 text-xs"
          style={{ color: "#d4ff3d" }}
        >
          Privacy policy del fornitore &rarr;
        </a>
      )}
    </div>
  );
}
